
//import Top from "../components/Top";
import { useQuery } from "@tanstack/react-query";
import Spinner from 'react-bootstrap/Spinner';
import { API_BASE_URL } from "../api/config";

//import styles from "../style.module.css";
import parse from 'html-react-parser';


function Privacy() {


  const { isLoading, isError, data, error } = useQuery({
    queryKey: ['privacy-page'],
    queryFn: async () => {
      const res = await fetch(`${API_BASE_URL}/api/user/pages/privacy`);
      return await res.json();
    },
  })

  if (isLoading) {
    return <div className="d-flex flex-column justify-content-center justify-content-center align-items-center" style={{ height: "50vh" }}>
      <Spinner animation="border" role="status" style={{ height: "89px", width: "89px" }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <p className="mt-3">Kindly be patient while we fetch your data</p>
    </div>
  }
  if (isError) {
    return (
      <p>An Error Occurred : {error.message}</p>
    )
  }



  return (
    <div className="privacy mx-auto mb-5" style={{ width: "80%" }} >
      <h3>{data?.title}</h3>
      {parse(data?.content)}
    </div>
  );
}

export default Privacy;
